import * as React from 'react';
import { Box, CircularProgress, Paper, Typography } from '@mui/material';
import useMobileScreen from '../../../../lib/useMobileScreen';
import DesktopTable from './DesktopTable';
import MobileTable from './MobileTable';
import { IDataProcessos } from '../../../../types/api/bpm/pesquisar-processos';
import { useModalDetalheProcesso } from '../../../../components/ModalContexts/ModalDetalheProcessoContext';

export default function SolicitacoesRessuprimento({ isLoading, processos }: SolicitacoesRessuprimentoProps) {

    const telaMobile = useMobileScreen()
    const { openModal } = useModalDetalheProcesso();

    //Funções Manipuladoras
    const handleOpenModalDetail = React.useCallback((codigo: string) => {
        openModal(codigo)
    }, [openModal])
    //

    return (
        <Box component={Paper}>
            <Typography variant='h6' p={2}>Solicitações de ressuprimento enviadas</Typography>

            {isLoading && <CircularProgress style={{ margin: 12, marginTop: 24 }} />}

            {
                (processos && !telaMobile) &&
                <DesktopTable
                    processos={processos.data as IDataProcessos[]}
                    {...{ handleOpenModalDetail }}
                    total={processos.total}
                />
            }

            {
                (processos && telaMobile) &&
                <MobileTable
                    processos={processos.data as IDataProcessos[]}
                    {...{ handleOpenModalDetail }}
                />
            }
        </Box>
    )
}

interface SolicitacoesRessuprimentoProps {
    isLoading: boolean,
    processos: {
        total: number,
        per_page: number,
        current_page: number,
        data: Array<object>
    }
}

export interface ResponsiveTableProps {
    processos: IDataProcessos[],
    handleOpenModalDetail: (arg: string) => void,
    total?: number
}